import React from 'react'
import { SortButtons } from '../SortButtons';


const TableHeaderItem = ({ title, sortBy, sortDirection, callBack }) => {

  const handleSort = React.useCallback((sortBy) => {
    if (sortDirection === 'desc') {
      callBack("asc", sortBy)
    }
    else {
      callBack("desc", sortBy)
    }
  }, [sortDirection])
  return (
    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <p>{title}</p>
      <span className='ml-2'>
        {(sortDirection && sortBy) &&
        <SortButtons
          upActive={sortDirection == "asc"}
          downActive={sortDirection == "desc"}
          handleSort={() => handleSort(sortBy)}
        />
        }
      </span>
    </div>
  );
}

export default TableHeaderItem